import './App.css'
import { useEffect, useState } from 'react'
import Web3 from 'web3'
import {
  createWeb3Modal,
  defaultConfig,
  useWeb3Modal,
  useWeb3ModalAccount,
  useWeb3ModalEvents,
  useWeb3ModalState
} from '@web3modal/ethers5/react'
import {
  PROJECT_ID,
  METADATA,
  CHAINS,
  CURRENCY_ICONS,
  SOVINPASS_ADDRESS,
  SOVINPASS_ABI
} from './config'
import { shortAddr } from './utils'

createWeb3Modal({
  projectId: PROJECT_ID,
  ethersConfig: defaultConfig({ METADATA }),
  chains: CHAINS,
  defaultChain: CHAINS[0],
  featuredWalletIds: [
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
    '19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927',
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4'
  ],
  themeMode: 'dark'
})

let tokensIdArr = []
let tokensOwnerArr = []
let tokensUriArr = []
let tokensInfoArr = []

const filterOptions = [
  'My NFT',
  'All NFT'
]

const App = () => {
  const { open } = useWeb3Modal()
  const { address, isConnected } = useWeb3ModalAccount()
  const { selectedNetworkId } = useWeb3ModalState()
  const events = useWeb3ModalEvents()

  const [web3, setWeb3] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [account, setAccount] = useState(null)
  const [balance, setBalance] = useState('')
  const [currency, setCurrency] = useState(null)
  const [sovinpass, setSovinpass] = useState(null)
  const [sovinpassOwner, setSovinpassOwner] = useState(null)
  const [tokensCount, setTokensCount] = useState(null)
  const [tokensId, setTokensId] = useState(null)
  const [tokensOwner, setTokensOwner] = useState(null)
  const [tokensUri, setTokensUri] = useState(null)
  const [tokensInfo, setTokensInfo] = useState(null)
  const [mintVisible, setMintVisible] = useState(false)
  const [mintLoading, setMintLoading] = useState(null)
  const [burnVisible, setBurnVisible] = useState(false)
  const [burnLoading, setBurnLoading] = useState(null)
  const [toValue, setToValue] = useState('')
  const [levelValue, setLevelValue] = useState('')
  const [idValue, setIdValue] = useState('')
  const [messageText, setMessageText] = useState('')
  const [messageVisible, setMessageVisible] = useState(false)
  const [filter, setFilter] = useState(1)
  const [filterOpened, setFilterOpened] = useState(false)
  const [tokensVisible, setTokensVisible] = useState([])
  const [tokenOpened, setTokenOpened] = useState(null)

  const load = async () => {
    await loadWeb3()
  }

  const loadWeb3 = async () => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged)
      setWeb3(new Web3(window.ethereum))
      setLoaded(true)
    }
  }

  const handleAccountsChanged = (accounts) => {
    if (!account || !accounts[0] || account.toLowerCase() !== accounts[0].toLowerCase()) {
      setAccount(accounts[0])
    }
  }

  const clearData = () => {
    tokensIdArr = []
    tokensOwnerArr = []
    tokensUriArr = []
    tokensInfoArr = []
    setTokensCount(null)
    setTokensId(null)
    setTokensOwner(null)
    setTokensUri(null)
    setTokensInfo(null)
    setTokensVisible([])
  }

  const estimateGas = async (trxParams, onSuccess, onError) => {
    web3.eth.estimateGas(trxParams)
      .then((gasVal) => {
        console.log('Estimate gas value:', gasVal)
        const gasValInt = parseInt(gasVal, 16)
        if (gasValInt > 0) {
          trxParams.gas = parseInt(gasValInt * 1.0).toString()
        }
        if (typeof onSuccess === 'function') {
          onSuccess(trxParams)
        }
      })
      .catch((error) => {
        console.log('Estimate gas failed:', error)
        if (typeof onError === 'function') {
          onError()
        }
      })
  }

  const getBalance = async () => {
    console.log('Get balance ...')
    web3.eth.getBalance(account)
      .then((receipt) => {
        console.log('Get balance success:', receipt)
        setBalance((receipt / Math.pow(10, 18)))
      })
      .catch((error) => {
        console.log('Get balance error:', error)
      })
  }

  const getAllTokensCount = async () => {
    console.log('Get all tokens count...')
    clearData()
    sovinpass.methods.totalSupply().call()
      .then((count) => {
        if (count) {
          count = Number(count)
          console.log('Get all tokens count success:', count)
          setTokensCount(count)
          if (count > 0) {
            getTokensInfo(count)
          }
        } else {
          console.log('Get all tokens count error: no returned count.')
        }
      })
      .catch((error) => {
        console.log('Get all tokens count error:', error)
      })
  }

  const getTokensCount = async () => {
    console.log('Get tokens count...', account)
    clearData()
    sovinpass.methods.balanceOf(account).call()
      .then((count) => {
        if (count) {
          count = Number(count)
          console.log('Get tokens count success:', count)
          setTokensCount(count)
          if (count > 0) {
            getTokensInfo(count)
          }
        } else {
          console.log('Get tokens count error: no returned count.')
        }
      })
      .catch((error) => {
        console.log('Get tokens count error:', error)
      })
  }

  const getTokensInfo = async (count) => {
    console.log('Get tokens info...')
    const isOwner = account.toLowerCase() === sovinpassOwner.toLowerCase()
    for (let ind = 0; ind < count; ind++) {
      if (isOwner) {
        getAllTokenId(ind)
      } else {
        getTokenId(ind)
      }
    }
  }

  const getAllTokenId = async (ind) => {
    console.log('Get all token #' + ind + ' ID...')
    sovinpass.methods.tokenByIndex(ind).call()
      .then((tokenId) => {
        if (tokenId) {
          console.log('Get all token #' + ind + ' ID success:', tokenId)
          const newTokensIdArr = [ ...tokensIdArr, tokenId ]
          tokensIdArr = newTokensIdArr
          setTokensId(tokensIdArr)
          getTokenOwner(ind, tokenId)
          getTokenUri(ind, tokenId)
        } else {
          console.log('Get all token #' + ind + ' ID error: no returned ID.')
        }
      })
      .catch((error) => {
        console.log('Get all token #' + ind + ' ID error:', error)
      })
  }

  const getTokenId = async (ind) => {
    console.log('Get token #' + ind + ' ID...')
    sovinpass.methods.tokenOfOwnerByIndex(account, ind).call()
      .then((tokenId) => {
        if (tokenId) {
          console.log('Get token #' + ind + ' ID success:', tokenId)
          const newTokensIdArr = [ ...tokensIdArr, tokenId ]
          tokensIdArr = newTokensIdArr
          setTokensId(tokensIdArr)
          getTokenOwner(ind, tokenId)
          getTokenUri(ind, tokenId)
        } else {
          console.log('Get token #' + ind + ' ID error: no returned ID.')
        }
      })
      .catch((error) => {
        console.log('Get token #' + ind + ' ID error:', error)
      })
  }

  const getTokenOwner = async (ind, tokenId) => {
    console.log('Get token #' + ind + ' owner...')
    sovinpass.methods.ownerOf(tokenId).call()
      .then((tokenOwner) => {
        if (tokenOwner) {
          console.log('Get token #' + ind + ' owner success:', tokenOwner)
          console.log('Get token #' + ind + ' code...')
          web3.eth.getCode(tokenOwner)
            .then((tokenCode) => {
              if (tokenCode) {
                console.log('Get token #' + ind + ' code success:', tokenCode)
                const newTokensOwnerArr = [ ...tokensOwnerArr, { id: tokenId, owner: tokenOwner, isContract: tokenCode !== '0x' } ]
                tokensOwnerArr = newTokensOwnerArr
                setTokensOwner(tokensOwnerArr)
              } else {
                console.log('Get token #' + ind + ' code error: no returned code.')
              }
            })
            .catch((error) => {
              console.log('Get token #' + ind + ' code error:', error)
            })
        } else {
          console.log('Get token #' + ind + ' owner error: no returned owner.')
        }
      })
      .catch((error) => {
        console.log('Get token #' + ind + ' owner error:', error)
      })
  }

  const getTokenUri = async (ind, tokenId) => {
    console.log('Get token #' + ind + ' URI...')
    sovinpass.methods.tokenURI(tokenId).call()
      .then((tokenUri) => {
        if (tokenUri) {
          console.log('Get token #' + ind + ' URI success:', tokenUri)
          const newTokensUriArr = [ ...tokensUriArr, { id: tokenId, uri: tokenUri } ]
          tokensUriArr = newTokensUriArr
          setTokensUri(tokensUriArr)
          getTokenInfo(ind, tokenId, tokenUri)
        } else {
          console.log('Get token #' + ind + ' URI error: no returned URI.')
        }
      })
      .catch((error) => {
        console.log('Get token #' + ind + ' URI error:', error)
      })
  }

  const getTokenInfo = async (ind, tokenId, tokenUri) => {
    console.log('Get token #' + ind + ' info...')
    fetch(tokenUri, { method: 'get' })
      .then((response) => {
        return response.json()
      })
      .then((tokenInfo) => {
        if (tokenInfo) {
          console.log('Get token #' + ind + ' info success:', tokenInfo)
          const newTokensInfoArr = [ ...tokensInfoArr, { id: tokenId, info: tokenInfo } ]
          tokensInfoArr = newTokensInfoArr
          setTokensInfo(tokensInfoArr)
        } else {
          console.log('Get token #' + ind + ' info error: no returned info.')
        }
      })
      .catch((error) => {
        console.log('Get token #' + ind + ' info error: ', error)
      })
  }

  const sovinpassCreate = async () => {
    console.log('Create SovinPass.')
    const obj = new web3.eth.Contract(SOVINPASS_ABI, SOVINPASS_ADDRESS)
    setSovinpass(obj)
  }

  const sovinpassGetOwner = async () => {
    console.log('Get SovinPass owner...')
    sovinpass.methods.owner().call()
      .then((owner) => {
        if (owner) {
          console.log('Get SovinPass owner success:', owner)
          setSovinpassOwner(owner)
        }
      })
      .catch((error) => {
        console.log('Get SovinPass owner error:', error)
      })
  }

  const sovinpassMintToken = async () => {
    setMintLoading(true)
    const params = {
      toAddr: toValue,
      level: levelValue
    }
    const trxParams = {
      to: sovinpass._address,
      from: account,
      data: sovinpass.methods.MintNext(...Object.values(params)).encodeABI(),
    }
    estimateGas(trxParams, (trxParams) => {
      console.log('Mint token...')
      web3.eth.sendTransaction(trxParams)
        .on('transactionHash', (trxHash) => {
          console.log('Mint token transactionHash:', trxHash)
        })
        .on('receipt', ({ logs }) => {
          if (logs) {
            console.log('Mint token success.')
            getBalance()
            getAllTokensCount()
            setMintVisible(false)
            setToValue('')
            setLevelValue('')
          } else {
            console.log('Mint token error: no returned data.')
          }
          setMintLoading(false)
        })
        .on('error', (error) => {
          console.log('Mint token failed:', error)
          setMintLoading(false)
        })
    }, () => {
      setMintLoading(false)
    })
  }

  const sovinpassBurnToken = (id) => {
    setBurnLoading(true)
    const trxParams = {
      to: sovinpass._address,
      from: account,
      data: sovinpass.methods.Burn(id).encodeABI(),
    }
    estimateGas(trxParams, (trxParams) => {
      console.log('Burn token...')
      web3.eth.sendTransaction(trxParams)
        .on('transactionHash', (trxHash) => {
          console.log('Burn token transactionHash:', trxHash)
        })
        .on('receipt', ({ logs }) => {
          if (logs) {
            console.log('Burn token success.')
            getBalance()
            getAllTokensCount()
            setBurnVisible(false)
            setToValue('')
            setLevelValue('')
          } else {
            console.log('Burn token error: no returned data.')
          }
          setBurnLoading(false)
        })
        .on('error', (error) => {
          console.log('Burn token failed:', error)
          setBurnLoading(false)
        })
    }, () => {
      setBurnLoading(false)
    })
  }

  const buttonBasicClick = () => {
    setMessageText('You clicked Basic Button')
    setMessageVisible(true)
  }

  const buttonAdvancedClick = () => {
    setMessageText('You clicked Advanced Button')
    setMessageVisible(true)
  }

  const buttonPrivelegedClick = () => {
    setMessageText('You clicked Priveleged Button')
    setMessageVisible(true)
  }

  const buttonEliteClick = () => {
    setMessageText('You clicked Elite Button')
    setMessageVisible(true)
  }

  const buttonLegendaryClick = () => {
    setMessageText('You clicked Legendary Button')
    setMessageVisible(true)
  }

  const changeTokensVisible = (id) => {
    if (tokensVisible.includes(id)) {
      setTokensVisible(tokensVisible.filter(el => el !== id))
    } else {
      setTokensVisible([...tokensVisible, id])
    }
  }

  useEffect(() => {
    if (!loaded) {
      load()
    }
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        setFilterOpened(false)
        setMintVisible(false)
        setBurnVisible(false)
        setMessageVisible(false)
        setMessageText('')
        setTokenOpened(null)
      }
    })
  })

  useEffect(() => {
    const name = events.data.event
    console.log('Web3modal Event:', name)
  }, [events])

  useEffect(() => {
    if (web3 && !sovinpass) {
      sovinpassCreate()
    }
  }, [web3])

  useEffect(() => {
    if (!isConnected) {
      setAccount(null)
      clearData()
    }
  }, [isConnected])

  useEffect(() => {
    console.log('Network set to:', selectedNetworkId)
    if (selectedNetworkId) {
      const chain = CHAINS.find(ch => ch.chainId.toString() === selectedNetworkId.toString())
      if (chain) {
        setCurrency(chain.currency)
      } else {
        setCurrency(null)
      }
    } else {
      setCurrency(null)
    }
  }, [selectedNetworkId])

  useEffect(() => {
    if (!account || !address || account.toLowerCase() !== address.toLowerCase()) {
      setAccount(address)
    }
  }, [address])

  useEffect(() => {
    console.log('Account set to:', account, sovinpassOwner)
    if (account) {
      getBalance()
      if (sovinpass && sovinpassOwner) {
        if (account.toLowerCase() === sovinpassOwner.toLowerCase()) {
          getAllTokensCount()
        } else {
          getTokensCount()
        }
      } else {
        clearData()
      }
    } else {
      clearData()
    }
    if (sovinpass && !sovinpassOwner) {
      sovinpassGetOwner()
    }
  }, [account, sovinpass, sovinpassOwner])

  const connectParams = CHAINS.length > 1 ? { view: 'Networks' } : {}
  let level = 0
  let tokensInfoList = []
  let tokensOwnerList = []
  if (tokensInfo && tokensCount > 0) {
    tokensInfoList = tokensInfo.sort((a, b) => parseInt(a.id) < parseInt(b.id) ? 1 : parseInt(a.id) > parseInt(b.id) ? -1 : 0)
    if (tokensOwner && account) {
      tokensInfoList = tokensInfoList.map(el => {
        const to = tokensOwner.find(o => parseInt(o.id) === parseInt(el.id))
        return to ? { ...el, owner: to.owner, isContract: to.isContract } : el
      })
      tokensInfoList = tokensInfoList.sort((a, b) => parseInt(a.owner) < parseInt(b.owner) ? 1 : parseInt(a.owner) > parseInt(b.owner) ? -1 : 0)
      const ownList = tokensInfoList.filter(el => el.owner && el.owner.toLowerCase() === account.toLowerCase())
      if (ownList.length > 0) {
        level = Math.max(...ownList.map(el => el.info.attributes.find(a => a.trait_type === 'Level').value))
      }
      if (filter === 0) {
        tokensInfoList = ownList
      }
    }
  }

  return (
    <div className="app" data-theme="dark" onClick={() => { setFilterOpened(false); setMintVisible(false); setBurnVisible(false); setMessageVisible(false); setMessageText(''); setTokenOpened(null) }}>
      <div className="blocks">
        {(isConnected && account) && <div className="block">
          <div className="title num center" data-network={selectedNetworkId}>{shortAddr(account)}</div>
          <div className="balance num" dangerouslySetInnerHTML={{ __html: balance ? (balance + (currency ? (' ' + CURRENCY_ICONS.find(el => el.currency === currency)?.icon) : '')) : ''}} />
          <div className="level" data-level={level}>Level</div>
        </div>}
        <div className="block controls">
          {isConnected
            ? <>
                <button onClick={() => open()}>Change Wallet</button>
                {account && <>
                  {(sovinpass && sovinpassOwner && account.toLowerCase() === sovinpassOwner.toLowerCase()) 
                    ? <>
                        <div className="controls">
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" className="mint" onClick={(e) => { e.stopPropagation(); setMintVisible(true) }}><g><path d="M231.869 446.505c17.768 7.158 76.621 26.86 139.466 3.736 12.351 9.893 30.396 8.081 40.516-4.158a28.892 28.892 0 0 0 6.523-15.685c10.621 2.824 22.393-.527 29.855-9.552 6.812-8.239 8.304-19.118 4.884-28.484 8.54.159 17.069-3.427 22.934-10.521 9.263-11.203 8.703-27.29-.69-37.811a28.924 28.924 0 0 0 18.259-10.24c11.04-13.171 7.936-33.502-6.498-42.804 23.637-9.213 23.038-45.494-1.018-53.838 19.129-13.283 13.683-44.929-8.672-51.15 11.725-12.036 10.603-31.871-2.397-42.519-12.901-10.768-32.594-8.142-42.212 5.635-10.314-20.791-42.417-20.187-51.868 1.094-4.899-6.127-11.068-10.267-17.631-12.475M343.054 314.617l77.106-10.663M294.716 389.881l84.141-6.535M349.618 295.161l51.276-62.016M112.855 216.068l65.732 71.63 65.731-71.63M92.293 311.983l86.293 83.407 86.294-83.407M178.587 469.817V169.71M328.974 144.655c-5.653 5.202-9.88 12.689-11.524 22.424" fill="none" className="stroke" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"></path><path d="M100.241 429.167c38.947 31.052 78.346 40.65 78.346 40.65s82.396-20.058 126.662-96.072c17.343-.27 31.321-14.404 31.321-31.811a31.682 31.682 0 0 0-5.444-17.806c10.945-5.032 18.548-16.085 18.548-28.921 0-11.718-6.338-21.95-15.769-27.473 7.325-5.83 12.025-14.816 12.025-24.906 0-15.933-11.709-29.131-26.992-31.459a31.704 31.704 0 0 0 8.272-21.403c.127-18.837-16.697-33.843-35.386-31.62 13.533-24.292-12.314-54.522-38.463-44.768 6.882-24.581-19.822-47.51-43.052-37.152 1.498-18.356-13.304-34.329-31.723-34.244-18.419-.086-33.22 15.888-31.723 34.244C123.629 66.067 96.932 89 103.811 113.578c-26.155-9.756-51.994 20.483-38.463 44.768-18.691-2.223-35.512 12.783-35.386 31.62a31.71 31.71 0 0 0 8.272 21.403c-15.283 2.328-26.992 15.526-26.992 31.459 0 10.089 4.7 19.075 12.025 24.906C13.838 273.257 7.5 283.489 7.5 295.207c0 12.836 7.604 23.889 18.548 28.921a31.674 31.674 0 0 0-5.444 17.806c0 17.407 13.978 31.541 31.321 31.811 6.85 11.763 14.614 22.182 22.843 31.398" fill="none" className="stroke" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"></path></g></svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" className="burn" onClick={(e) => { e.stopPropagation(); setBurnVisible(true) }}><g><path d="M350.534 290.822c35.248-28.071 59.291-56.833 69.775-92.761 16.817 28.955 27.096 64.914 27.791 104.023 4.756 267.646-388.682 252.011-384.205 0 .695-39.109 10.974-75.068 27.79-104.022 8.243 28.248 24.869 56.392 48.731 80.777C140.416 159.999 259.358 142 233.118 15c129.24 66 145.09 174.999 117.416 275.822z" fillRule="evenodd" clipRule="evenodd" fill="none" className="stroke" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="22.9256"></path><path d="M253.1 496.827a219.067 219.067 0 0 1-21.861-1.839c-30.642-4.133-54.769-23.579-65.317-52.644-10.548-29.066-4.506-59.46 16.356-82.283 32.204-35.229 62.278-77.352 62.827-159.27 41.031 67.696 77.302 131.819 90.298 199.888 4.776 25.015-1.469 48.519-18.029 67.866-16.561 19.347-38.822 29.142-64.274 28.282z" fillRule="evenodd" clipRule="evenodd" fill="none" className="stroke" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="22.9256"></path></g></svg>
                        </div>
                        <div className="form zoomIn" data-visible={mintVisible} onClick={(e) => e.stopPropagation()}>
                          <div className="title">Mint Token</div>
                          <div className="field">
                            <div className="label">to:</div>
                            <input type="text" name="to" value={toValue} placeholder="address" onChange={(e) => setToValue(e.target.value)} />
                          </div>
                          <div className="field">
                            <div className="label">level:</div>
                            <div className="radios">
                              <button data-active={levelValue === 1} onClick={(e) => setLevelValue(1)}>1</button>
                              <button data-active={levelValue === 2} onClick={(e) => setLevelValue(2)}>2</button>
                              <button data-active={levelValue === 3} onClick={(e) => setLevelValue(3)}>3</button>
                              <button data-active={levelValue === 4} onClick={(e) => setLevelValue(4)}>4</button>
                              <button data-active={levelValue === 5} onClick={(e) => setLevelValue(5)}>5</button>
                            </div>
                          </div>
                          <div className="field buttons">
                            {mintLoading
                              ? <div className="note flash">minting token...</div>
                              : <>
                                  <button type="reset" onClick={() => setMintVisible(false)}>Cancel</button>
                                  <button type="submit" onClick={() => sovinpassMintToken()} disabled={!toValue || !levelValue}>Mint</button>
                                </>
                            }
                          </div>
                        </div>
                        <div className="form zoomIn" data-visible={burnVisible} onClick={(e) => e.stopPropagation()}>
                          <div className="title">Burn Token</div>
                          <div className="field">
                            <div className="label">token ID:</div>
                            <input type="text" name="id" value={idValue} placeholder="id" onChange={(e) => setIdValue(e.target.value)} />
                          </div>
                          <div className="field buttons">
                            {burnLoading
                              ? <div className="note flash">burning token...</div>
                              : <>
                                  <button type="reset" onClick={() => setBurnVisible(false)}>Cancel</button>
                                  <button type="submit" onClick={() => sovinpassBurnToken(idValue)} disabled={!idValue}>Burn</button>
                                </>
                            }
                          </div>
                        </div>
                      </>
                    : <div />
                  }
                </>}
              </>
            : <button onClick={() => open(connectParams)}>Connect Wallet</button>
          }
        </div>
        {(isConnected && account && sovinpass) && <>
          <hr />
          <div className="block tokens-controls">
            <button data-level="1" disabled={level < 1} onClick={(e) => { e.stopPropagation(); buttonBasicClick() }}>Basic</button>
            <button data-level="2" disabled={level < 2} onClick={(e) => { e.stopPropagation(); buttonAdvancedClick() }}>Advanced</button>
            <button data-level="3" disabled={level < 3} onClick={(e) => { e.stopPropagation(); buttonPrivelegedClick() }}>Priveleged</button>
            <button data-level="4" disabled={level < 4} onClick={(e) => { e.stopPropagation(); buttonEliteClick() }}>Elite</button>
            <button data-level="5" disabled={level < 5} onClick={(e) => { e.stopPropagation(); buttonLegendaryClick() }}>Legendary</button>
          </div>
          <hr />
          {(tokensInfo && tokensInfo.length > 0)
            ? <div className="block">
                <div className="tokens-list-title fadeInUp">
                  <span className="title">{filterOptions[(sovinpassOwner && account.toLowerCase() === sovinpassOwner.toLowerCase()) ? filter : 0]}</span>
                  <span className="tokens-count num">/{tokensInfoList.length}/</span>
                  {(sovinpassOwner && account.toLowerCase() === sovinpassOwner.toLowerCase()) && <div className="select">
                    <div className="selected" onClick={(e) => { e.stopPropagation(); setFilterOpened(!filterOpened) }}>
                      <span>{filterOptions[filter]}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path d="M510.078,35.509c-3.388-7.304-10.709-11.977-18.761-11.977H20.682c-8.051,0-15.372,4.672-18.761,11.977 s-2.23,15.911,2.969,22.06l183.364,216.828v146.324c0,7.833,4.426,14.995,11.433,18.499l94.127,47.063 c2.919,1.46,6.088,2.183,9.249,2.183c3.782,0,7.552-1.036,10.874-3.089c6.097-3.769,9.809-10.426,9.809-17.594V274.397 L507.11,57.569C512.309,51.42,513.466,42.813,510.078,35.509z M287.27,253.469c-3.157,3.734-4.889,8.466-4.889,13.355V434.32 l-52.763-26.381V266.825c0-4.89-1.733-9.621-4.89-13.355L65.259,64.896h381.482L287.27,253.469z" className="fill"/></svg>
                    </div>
                    {filterOpened && <div className="options fadeInDown" onClick={(e) => e.stopPropagation()}>
                      {filterOptions.map((el, key) => 
                        <div key={key} data-active={filter === key} onClick={() => {setFilter(key); setFilterOpened(false)}}>{el}</div>
                      )}
                    </div>}
                  </div>}
                </div>
                <div className="tokens-list">
                  {tokensInfoList.map((el, key) => {
                    let ind = 0
                    if (tokensOwnerList.includes(el.owner)) {
                      ind ++
                    } else {
                      ind = 0
                      tokensOwnerList.push(el.owner)
                    }
                    return <>
                      {(filter !== 0 && sovinpassOwner && account.toLowerCase() === sovinpassOwner.toLowerCase() && el.owner) && <div key={key + 'o'} className="token-owner num" data-index={ind} onClick={() => changeTokensVisible(el.owner)}>
                        {shortAddr(el.owner)}
                        <span className="tokens-count">/{tokensInfoList.filter(i => i.owner === el.owner).length}/</span>
                        {el.isContract 
                          ? <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 48 48" className="contract"><g className="fill"><path d="M21 25c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3 3-1.346 3-3zm-3 1a1.001 1.001 0 0 1 0-2c.551 0 1 .449 1 1s-.449 1-1 1zM30 22c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4a1.001 1.001 0 0 1 0-2c.551 0 1 .449 1 1s-.449 1-1 1zM28.543 33.91c-2.815 1.447-6.271 1.447-9.086 0a1 1 0 1 0-.914 1.78c1.669.857 3.556 1.311 5.457 1.311s3.788-.453 5.457-1.311a1.001 1.001 0 0 0-.914-1.78z"></path><path d="M45 22h-3v-3c0-2.757-2.243-5-5-5H25V9.858c1.72-.447 3-2 3-3.858 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.858 1.28 3.411 3 3.858V14H11c-2.757 0-5 2.243-5 5v3H3c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h3v3c0 2.757 2.243 5 5 5h26c2.757 0 5-2.243 5-5v-3h3c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3zM22 6c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2zM3 35c-.551 0-1-.448-1-1v-9c0-.551.449-1 1-1h3v11zm37 5c0 1.654-1.346 3-3 3H11c-1.654 0-3-1.346-3-3V19c0-1.654 1.346-3 3-3h26c1.654 0 3 1.346 3 3zm6-6c0 .552-.449 1-1 1h-3V24h3c.551 0 1 .449 1 1z"></path></g></svg>
                          : <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" className="mint" onClick={(e) => { e.stopPropagation(); setToValue(el.owner); setMintVisible(true) }}><g><path d="M231.869 446.505c17.768 7.158 76.621 26.86 139.466 3.736 12.351 9.893 30.396 8.081 40.516-4.158a28.892 28.892 0 0 0 6.523-15.685c10.621 2.824 22.393-.527 29.855-9.552 6.812-8.239 8.304-19.118 4.884-28.484 8.54.159 17.069-3.427 22.934-10.521 9.263-11.203 8.703-27.29-.69-37.811a28.924 28.924 0 0 0 18.259-10.24c11.04-13.171 7.936-33.502-6.498-42.804 23.637-9.213 23.038-45.494-1.018-53.838 19.129-13.283 13.683-44.929-8.672-51.15 11.725-12.036 10.603-31.871-2.397-42.519-12.901-10.768-32.594-8.142-42.212 5.635-10.314-20.791-42.417-20.187-51.868 1.094-4.899-6.127-11.068-10.267-17.631-12.475M343.054 314.617l77.106-10.663M294.716 389.881l84.141-6.535M349.618 295.161l51.276-62.016M112.855 216.068l65.732 71.63 65.731-71.63M92.293 311.983l86.293 83.407 86.294-83.407M178.587 469.817V169.71M328.974 144.655c-5.653 5.202-9.88 12.689-11.524 22.424" fill="none" className="stroke" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"></path><path d="M100.241 429.167c38.947 31.052 78.346 40.65 78.346 40.65s82.396-20.058 126.662-96.072c17.343-.27 31.321-14.404 31.321-31.811a31.682 31.682 0 0 0-5.444-17.806c10.945-5.032 18.548-16.085 18.548-28.921 0-11.718-6.338-21.95-15.769-27.473 7.325-5.83 12.025-14.816 12.025-24.906 0-15.933-11.709-29.131-26.992-31.459a31.704 31.704 0 0 0 8.272-21.403c.127-18.837-16.697-33.843-35.386-31.62 13.533-24.292-12.314-54.522-38.463-44.768 6.882-24.581-19.822-47.51-43.052-37.152 1.498-18.356-13.304-34.329-31.723-34.244-18.419-.086-33.22 15.888-31.723 34.244C123.629 66.067 96.932 89 103.811 113.578c-26.155-9.756-51.994 20.483-38.463 44.768-18.691-2.223-35.512 12.783-35.386 31.62a31.71 31.71 0 0 0 8.272 21.403c-15.283 2.328-26.992 15.526-26.992 31.459 0 10.089 4.7 19.075 12.025 24.906C13.838 273.257 7.5 283.489 7.5 295.207c0 12.836 7.604 23.889 18.548 28.921a31.674 31.674 0 0 0-5.444 17.806c0 17.407 13.978 31.541 31.321 31.811 6.85 11.763 14.614 22.182 22.843 31.398" fill="none" className="stroke" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"></path></g></svg>}
                        <span className="tokens-toggle" data-opened={tokensVisible.includes(el.owner)} />
                      </div>}
                      <div key={key + 'i'} className="token fadeInUp" data-index={el.id} data-disabled={burnLoading === el.id} data-level={el.info.attributes.find(a => a.trait_type === 'Level').value} data-opened={tokensVisible.includes(el.owner) || filter === 0 || sovinpassOwner.toLowerCase() !== account.toLowerCase()} onClick={(e) => { e.stopPropagation(); setTokenOpened(el) }}>
                        <div className="token-img">
                          {el.info.image && <img src={el.info.image} alt={el.id} />}
                        </div>
                      </div>
                    </>
                  })}
                </div>
              </div>
            : <div className="block fadeInUp">
                {(account && sovinpass && sovinpassOwner && account.toLowerCase() === sovinpassOwner.toLowerCase())
                  ? <div className="center">You don't have NFT</div>
                  : <div className="center">You don't have permission</div>
                }
              </div>
          }
        </>}
        {((sovinpassOwner && account.toLowerCase() !== sovinpassOwner.toLowerCase()) || filter === 0) && <>
          <hr />
          <div className="block note fadeInUp">
            <div className="center">
              <span className="label">You can buy more tokens in&nbsp;</span>
              <a href="https://market.sovin.net/">Sovin&nbsp;Market</a>
            </div>
          </div>
        </>}
        <div className="message zoomIn" data-visible={messageVisible} onClick={(e) => e.stopPropagation()}>
          <div className="message-text" dangerouslySetInnerHTML={{ __html: messageText }} />
          <button onClick={() => { setMessageVisible(false); setMessageText('') }}>Close</button>
        </div>
        <div className="token-detail zoomIn" data-visible={tokenOpened !== null} onClick={(e) => e.stopPropagation()}>
          <div className="token-detail-content">
            <div className="token-detail-head">
              <div className="token-detail-title num">{tokenOpened && tokenOpened.owner && shortAddr(tokenOpened.owner)}</div>
              <div className="token-detail-buttons">
                {(tokenOpened && !tokenOpened.isContract && account.toLowerCase() === sovinpassOwner.toLowerCase()) && <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" className="burn" onClick={() => { sovinpassBurnToken(tokenOpened?.id); setTokenOpened(null) }}><g><path d="M350.534 290.822c35.248-28.071 59.291-56.833 69.775-92.761 16.817 28.955 27.096 64.914 27.791 104.023 4.756 267.646-388.682 252.011-384.205 0 .695-39.109 10.974-75.068 27.79-104.022 8.243 28.248 24.869 56.392 48.731 80.777C140.416 159.999 259.358 142 233.118 15c129.24 66 145.09 174.999 117.416 275.822z" fillRule="evenodd" clipRule="evenodd" fill="none" className="stroke" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="22.9256"></path><path d="M253.1 496.827a219.067 219.067 0 0 1-21.861-1.839c-30.642-4.133-54.769-23.579-65.317-52.644-10.548-29.066-4.506-59.46 16.356-82.283 32.204-35.229 62.278-77.352 62.827-159.27 41.031 67.696 77.302 131.819 90.298 199.888 4.776 25.015-1.469 48.519-18.029 67.866-16.561 19.347-38.822 29.142-64.274 28.282z" fillRule="evenodd" clipRule="evenodd" fill="none" className="stroke" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="22.9256"></path></g></svg>}
                <div className="close" onClick={() => setTokenOpened(null) } />
              </div>
            </div>
            <div className="token" data-level={tokenOpened ? tokenOpened.info.attributes.find(a => a.trait_type === 'Level').value : 0}>
              <div className="token-img">
                {(tokenOpened && tokenOpened.info.image) && <img src={tokenOpened.info.image} alt={tokenOpened?.id} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App;
